import { FC, useEffect } from 'react';

import Code from '../../../Shared/Code';
import ContentGenerator from '../../../Shared/ContentGenerator';

import { useChatContext } from '../../ChatController/ChatController.context';

import { Content } from '../../../../types/tour';

export type Props = {
  setComplete: (stepIndex: number, parentIndex: number) => void;
  content: Content;
};

const codeSample = `
const message = await channel.sendMessage({
  text: "Did you already see the trailer? https://www.youtube.com/watch?v=wA38GCX4Tb0",
});

return message;
`;

export const Step4: FC<Props> = ({ setComplete, content }) => {
  const { sendMessage } = useChatContext();

  const run = async () => {
    await sendMessage();
    setComplete(4, 3);
  };

  return (
    <ContentGenerator
      content={content}
      code={
        <Code language="jsx" footer={{ label: 'Send Message', run }}>
          {codeSample}
        </Code>
      }
    />
  );
};
